// extracted by mini-css-extract-plugin
module.exports = {"content":"Survey_content__1en9O","flexContainer":"Survey_flexContainer__3aEAq","flexColumn":"Survey_flexColumn__3CXH0","layout":"Survey_layout__3XpmP"};